import type { Photographer } from "../store/types";

export const MOCK_PHOTOGRAPHERS: Photographer[] = [
  {
    id: "ph-001",
    photographer_code: "KY-001",
    display_name: "Kenji Yamamoto",
    legal_name: "山本健二",
    email: "kenji@tabifoto.jp",
    phone: "+81-75-000-0001",
    country_code: "JP",
    city_base: "Kyoto",
    languages: ["ja", "zh", "en"],
    status: "active",
    portfolio_url: "https://tabifoto.jp/ph/kenji",
    notes: "Specialises in portrait and street photography. Kyoto local for 10+ years.",
    is_active: true,
    created_at: "2025-01-10T00:00:00Z",
    updated_at: "2025-01-10T00:00:00Z",
  },
  {
    id: "ph-002",
    photographer_code: "TK-001",
    display_name: "Saki Nakamura",
    legal_name: "中村咲",
    email: "saki@tabifoto.jp",
    phone: "+81-3-000-0002",
    country_code: "JP",
    city_base: "Tokyo",
    languages: ["ja", "zh"],
    status: "active",
    portfolio_url: "https://tabifoto.jp/ph/saki",
    notes: "Natural light portrait, fashion, lifestyle.",
    is_active: true,
    created_at: "2025-02-01T00:00:00Z",
    updated_at: "2025-02-01T00:00:00Z",
  },
  {
    id: "ph-003",
    photographer_code: "OS-001",
    display_name: "Haruto Ito",
    legal_name: "伊藤陽翔",
    email: "haruto@tabifoto.jp",
    phone: "+81-6-000-0003",
    country_code: "JP",
    city_base: "Osaka",
    languages: ["ja", "zh", "en"],
    status: "active",
    portfolio_url: "https://tabifoto.jp/ph/haruto",
    notes: "Wedding and couple photography.",
    is_active: true,
    created_at: "2025-02-15T00:00:00Z",
    updated_at: "2025-02-15T00:00:00Z",
  },
  {
    id: "ph-004",
    photographer_code: "KY-002",
    display_name: "Yuki Tanaka",
    legal_name: "田中雪",
    email: "yuki@tabifoto.jp",
    phone: "+81-75-000-0004",
    country_code: "JP",
    city_base: "Kyoto",
    languages: ["ja", "zh"],
    status: "active",
    portfolio_url: "https://tabifoto.jp/ph/yuki",
    notes: "Landscape, kimono, shrine settings.",
    is_active: true,
    created_at: "2025-03-01T00:00:00Z",
    updated_at: "2025-03-01T00:00:00Z",
  },
  {
    id: "ph-005",
    photographer_code: "TK-002",
    display_name: "Ren Matsuda",
    legal_name: "松田蓮",
    email: "ren@tabifoto.jp",
    phone: "+81-3-000-0005",
    country_code: "JP",
    city_base: "Tokyo",
    languages: ["ja"],
    status: "on_leave",
    portfolio_url: "https://tabifoto.jp/ph/ren",
    notes: "Street, urban, editorial. Currently on leave until 2026-06-01.",
    is_active: false,
    created_at: "2025-04-01T00:00:00Z",
    updated_at: "2026-03-01T00:00:00Z",
  },
];
